import { gql } from "@apollo/client";

export const DELETE_MONITOR_EXCLUSION = gql`
  mutation deleteMonitorExclusion($input: DeleteForClientByIdInput!) {
    aml {
      deleteMonitorReferenceExclusion(input: $input) {
        success
      }
    }
  }
`;
